// import { BiChevronLeft, BiChevronRight } from "react-icons/bi"
import {
  Bed,
  Bath,
  Compass,
  EmptyButton
} from "../../../ApartmentFinderConfig/Icons/buttons/number/Icons"
import { useStore } from "../State/Store"
import {
  // BlockStrip,
  BuildingDiagramContainer,
  BuildingDiagramLayout,
  ControlsStrip,
  FilterButtonContainer,
  FilterButtonsContainer,
  FilterButtonStrip,
  UI
} from "./FilteringUI.style"
import { bedrooms, bathrooms, aspect } from "../Utils/config/global"
// import { useState } from "react"
import { useSpring } from "react-spring"
import SvgJSX from "../Components/SvgJSX"
import SVG from "react-inlinesvg"
// import { useAvailableApartments } from "../Utils/hooks"
import { hasNumber } from "../Utils/Helpers"
import { colours } from "../../../ApartmentFinderConfig/colours"

function FilteringUI({ show }) {
  const setCurrentCameraPositionID = useStore(
    state => state.setCurrentCameraPositionID
  )

  const setApartmentFinderActive = useStore(
    state => state.setApartmentFinderActive
  )
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)
  const activeBlock = useStore(state => state.activeBlock)
  const setActivateBlock = useStore(state => state.setActivateBlock)
  const setFavouritesActive = useStore(state => state.setFavouritesActive)

  const bedroomCounts = useStore(state => state.bedroomCounts)
  const resetBedCounts = useStore(state => state.resetBedCounts)

  const bathroomCounts = useStore(state => state.bathroomCounts)
  const toggleBathroomCounts = useStore(state => state.toggleBathroomCounts)
  const resetBathroomCounts = useStore(state => state.resetBedCounts)

  const toggleAspect = useStore(state => state.toggleAspect)
  const aspects = useStore(state => state.aspects)

  // console.log(aspects)

  const toggleBedroomCounts = useStore(state => state.toggleBedroomCounts)
  const props = useSpring({
    left: apartmentFinderActive ? 10 : -900
  })

  const toggleFinder = () => {
    setActivateBlock(null)
    setFavouritesActive(false)

    setCurrentCameraPositionID(apartmentFinderActive ? "wide" : "site")
    setApartmentFinderActive(!apartmentFinderActive)
  }

  const clearBlockSelection = () => {
    if (hasNumber(activeBlock)) {
      // setCurrentCameraPositionID("site")
      // console.log(activeBlock.charAt(0))
      setActivateBlock(activeBlock.charAt(0))
    } else {
      setActivateBlock(null)
      setCurrentCameraPositionID("site")
    }
  }
  const refreshFilter = () => {
    resetBedCounts()
    resetBathroomCounts()
  }

  const bedroomColours = {
    1: "#C95762",
    2: "#5B89B5",
    3: "#71A38A",
    4: "#A38D21"
  }
  // const bathroomolours = {
  //   1: "#C95762",
  //   2: "#5B89B5",
  //   3: "#71A38A",
  //   4: "#A38D21"
  // }

  return (
    <>
      <div
        style={{
          cursor: "pointer",
          zIndex: 2000,
          position: "absolute",
          right: "0%",
          bottom: "0%",
          margin: "1.5vw"
        }}
      >
        {activeBlock ? (
          <SVG
            style={{ cursor: "pointer" }}
            onClick={clearBlockSelection}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/close-icon.svg`}
            width={75}
            height={75}
            title="Exit"
          />
        ) : (
          <SVG
            style={{ cursor: "pointer" }}
            onClick={() => toggleFinder()}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/${
              apartmentFinderActive ? "toggleapoff" : "toggleapon"
            }.svg`}
            width={75}
            height={75}
            title="Exit"
          />
        )}
      </div>
      <UI style={props}>
        <FilterButtonsContainer>
          <FilterButtonStrip>
            <FilterButtonContainer>
              <Bed />
            </FilterButtonContainer>
            {bedrooms.map((_, i) => (
              <FilterButtonContainer key={i}>
                <EmptyButton
                  text={i + 1}
                  highlightColourOn={colours.primaryUI}
                  highlightColourOff={bedroomColours[i + 1]}
                  backgroundColourOff={colours.secondaryUI}
                  backgroundColourOn={bedroomColours[i + 1]}
                  textColorOn={colours.primaryUI}
                  textColorOff={bedroomColours[i + 1]}
                  isOn={bedroomCounts.includes(i + 1)}
                  onClick={() => toggleBedroomCounts(i + 1)}
                />
              </FilterButtonContainer>
            ))}
          </FilterButtonStrip>
          <FilterButtonStrip>
            <FilterButtonContainer>
              <Bath />
            </FilterButtonContainer>
            {bathrooms.map((_, i) => (
              <FilterButtonContainer key={i}>
                <EmptyButton
                  text={i + 1}
                  highlightColourOn={colours.primaryUI}
                  highlightColourOff={bedroomColours[i + 1]}
                  backgroundColourOff={colours.secondaryUI}
                  backgroundColourOn={bedroomColours[i + 1]}
                  textColorOn={colours.primaryUI}
                  textColorOff={bedroomColours[i + 1]}
                  isOn={bathroomCounts.includes(i + 1)}
                  onClick={() => toggleBathroomCounts(i + 1)}
                />
              </FilterButtonContainer>
            ))}
          </FilterButtonStrip>
          <FilterButtonStrip>
            <FilterButtonContainer>
              <Compass />
            </FilterButtonContainer>
            {aspect.map((v, i) => (
              <FilterButtonContainer key={i}>
                <EmptyButton
                  text={aspect[i]}
                  highlightColourOn={colours.primaryUI}
                  highlightColourOff={colours.secondaryU}
                  backgroundColourOff={colours.secondaryUI}
                  backgroundColourOn={colours.primaryUI}
                  textColorOn={colours.secondaryUI}
                  textColorOff={colours.primaryUI}
                  isOn={aspects.includes(v)}
                  onClick={() => toggleAspect(v)}
                />
              </FilterButtonContainer>
            ))}
          </FilterButtonStrip>
        </FilterButtonsContainer>
        <BuildingDiagramContainer>
          <BuildingDiagramLayout flex="5">
            <SvgJSX activeBlock={activeBlock} />
          </BuildingDiagramLayout>
        </BuildingDiagramContainer>

        <ControlsStrip>
          {activeBlock ? (
            <SVG
              style={{ cursor: "pointer" }}
              onClick={clearBlockSelection}
              src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/close-icon.svg`}
              width={50}
              height={50}
              title="Exit"
            />
          ) : (
            <SVG
              style={{ cursor: "pointer" }}
              onClick={() => toggleFinder()}
              src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/${
                apartmentFinderActive ? "toggleapoff" : "toggleapon"
              }.svg`}
              width={50}
              height={50}
              title="Menu"
            />
          )}
          {/* <BiChevronLeft
            // onClick={() => prevBlock()}
            style={{ cursor: "pointer" }}
          /> */}
          {activeBlock && hasNumber(activeBlock)
            ? `BLOCK ${activeBlock}`
            : "EXPLORE"}
          {/* <BiChevronRight
            // onClick={() => nextBlock()}
            style={{ cursor: "pointer" }}
          /> */}
          <SVG
            style={{ cursor: "pointer" }}
            onClick={() => refreshFilter()}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/refresh-icon.svg`}
            width={35}
            height={35}
            title="Menu"
          />
        </ControlsStrip>
        {/* <AvailableStrip>
          {availableApartments.length} Available Apartment
          {availableApartments.length === 1 ? "" : "s"}
        </AvailableStrip> */}
      </UI>
    </>
  )
}

export default FilteringUI
